let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("akKRc")).then(() => parcelRequire('jZccx'));